(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("customCertificates", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/customCertificatesView.html",
            controller: ["customCertificateResource", "messageService", "Upload", "$http", "$timeout", "$uibModal", "$window", CustomCertificatesCtrl],
            controllerAs: "vm"
        };
        function CustomCertificatesCtrl(customCertificateResource, messageService, Upload, $http, $timeout, $uibModal, $window) {
            var vm = this;
            vm.delete = deleteCertificate;
            vm.view = view;
            vm.upload = upload;
            loadData();
            ////////////////////////////////////////////////////
            function loadData() {
                vm.loading = true;
                customCertificateResource.getCustomCertificatesView(function (data) {
                    vm.certificates = data.customCertificates;
                    vm.loading = false;
                });
            }
            function deleteCertificate(pdf) {
                var modal = $uibModal.open({
                    templateUrl: "deleteCertificateConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    customCertificateResource.delete({ pdf: pdf }, function () {
                        loadData();
                        messageService.success("common.fileDeleted");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            }
            function view(pdf) {
                if (vm.downloading)
                    return;
                vm.preview = null;
                vm.downloading = true;
                var url = "api/customCertificates/" + pdf;
                $http.post(url, {}, { responseType: "arraybuffer" })
                    .then(function (result) {
                    $timeout(function () {
                        //https://stackoverflow.com/questions/24485077/how-to-open-blob-url-on-chrome-ios
                        var blob = new Blob([result.data], { type: "application/pdf" });
                        if ($window.navigator.userAgent.match("CriOS")) {
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                $window.open(reader.result);
                            };
                            reader.readAsDataURL(blob);
                            //} else if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                            //	window.saveAs(blob, "certificate.pdf");
                        }
                        else {
                            $window.URL = $window.URL || $window.webkitURL;
                            var url = $window.URL.createObjectURL(blob);
                            window.open(url);
                        }
                        vm.downloading = false;
                    });
                }, function () {
                    messageService.error("common.genericError");
                    vm.downloading = false;
                });
            }
            function upload(files) {
                vm.uploadResult = {};
                vm.error = null;
                if (files && files.length) {
                    vm.uploadResult = Upload.upload({
                        url: "api/customCertificates/upload",
                        data: { files: files }
                    });
                    vm.uploadResult.then(function () {
                        $timeout(function () {
                            vm.fileUploadProgressValue = 0;
                        }, 100);
                        $timeout(function () {
                            loadData();
                        });
                    }, function () {
                        vm.fileUploadProgressValue = 0;
                    }, function (evt) {
                        vm.fileUploadProgressValue = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            }
        }
    });
}());
